import { useSessionList } from 'hooks/sessions';
import SessionList from './components/SessionList';

const ListSession = () => {
  const { data, isLoading, isFetching, refetch, error } = useSessionList();

  const sessionList = data?.data;
  const loading = isLoading || isFetching;

  return (
    <div className="w-100">
      <h3>Sessions List</h3>

      <SessionList
        sessionList={sessionList || []}
        refetch={refetch}
        loading={loading}
        error={error}
      />
    </div>
  );
};

export default ListSession;
